export default function DialogIcon() {
  return (
    <svg
      width='108'
      height='66'
      viewBox='0 0 108 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_1974_76)'>
        <mask
          id='path-1-outside-1_1974_76'
          maskUnits='userSpaceOnUse'
          x='15'
          y='10'
          width='78'
          height='36'
          fill='black'
        >
          <rect fill='white' x='15' y='10' width='78' height='36' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M21 11C18.2386 11 16 13.2386 16 16V35C16 37.7614 18.2386 40 21 40H50.9208L54 44L57.0792 40H87C89.7614 40 92 37.7614 92 35V16C92 13.2386 89.7614 11 87 11H21Z'
          />
        </mask>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21 11C18.2386 11 16 13.2386 16 16V35C16 37.7614 18.2386 40 21 40H50.9208L54 44L57.0792 40H87C89.7614 40 92 37.7614 92 35V16C92 13.2386 89.7614 11 87 11H21Z'
          fill='#464E58'
        />
        <path
          d='M50.9208 40L51.7132 39.39L51.413 39H50.9208V40ZM54 44L53.2076 44.61L54 45.6394L54.7924 44.61L54 44ZM57.0792 40V39H56.587L56.2868 39.39L57.0792 40ZM17 16C17 13.7909 18.7909 12 21 12V10C17.6863 10 15 12.6863 15 16H17ZM17 35V16H15V35H17ZM21 39C18.7909 39 17 37.2091 17 35H15C15 38.3137 17.6863 41 21 41V39ZM50.9208 39H21V41H50.9208V39ZM50.1284 40.61L53.2076 44.61L54.7924 43.39L51.7132 39.39L50.1284 40.61ZM54.7924 44.61L57.8716 40.61L56.2868 39.39L53.2076 43.39L54.7924 44.61ZM87 39H57.0792V41H87V39ZM91 35C91 37.2091 89.2091 39 87 39V41C90.3137 41 93 38.3137 93 35H91ZM91 16V35H93V16H91ZM87 12C89.2091 12 91 13.7909 91 16H93C93 12.6863 90.3137 10 87 10V12ZM21 12H87V10H21V12Z'
          fill='white'
          mask='url(#path-1-outside-1_1974_76)'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_1974_76'
          x='0'
          y='0'
          width='108'
          height='65.6396'
          filterUnits='userSpaceOnUse'
          colorInterpolation-filters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='5' />
          <feGaussianBlur stdDeviation='7.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1974_76'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1974_76'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}
